module.exports = __webpack_public_path__ + "static/media/YB5F08_3.fd92108d.jpg";